import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[radial-gradient(ellipse_120%_90%_at_50%_-10%,#2b1494_0%,#220F86_45%,#0d0640_100%)] px-6 text-center" data-testid="payment-cancel-page">
      <div className="mb-10"><Logo /></div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-3xl border border-white/10 bg-navy-800/60 p-10 backdrop-blur-sm">
        <XCircle className="mx-auto mb-5 h-14 w-14 text-white/50" />
        <h1 className="text-2xl font-extrabold text-white">Assinatura não concluída</h1>
        <p className="mt-3 text-sm text-white/60">Você cancelou o checkout. Quando quiser, é só escolher um plano novamente — o teste de 7 dias continua disponível.</p>
        <Link to="/#planos" data-testid="back-plans-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-navy-700 transition-transform hover:scale-105">
          <ArrowLeft className="h-4 w-4" /> Ver planos
        </Link>
      </motion.div>
    </div>
  );
}
